/**
 * A sparkline: one place's weekly AZN/m² as a 12-point line, the last
 * point marked, coloured by the place. Pure SVG, no library, sized by
 * its container so it fits a table cell or a card corner.
 */
export default function Spark({ series, color = "#4f46e5", width = 96, height = 28, className = "" }: {
  series: { median_ppm: number | null }[];
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}) {
  const vals = series.map((p) => p.median_ppm);
  const known = vals.filter((v): v is number => v != null && v > 0);
  if (known.length < 2) return <span className={`inline-block ${className}`} style={{ width, height }} aria-hidden />;
  const min = Math.min(...known), max = Math.max(...known);
  const span = Math.max(max - min, max * 0.02, 1);
  const pts: [number, number][] = [];
  vals.forEach((v, i) => {
    if (v == null || v <= 0) return;
    const x = (i / Math.max(vals.length - 1, 1)) * (width - 4) + 2;
    const y = height - 3 - ((v - min) / span) * (height - 6);
    pts.push([x, y]);
  });
  const d = pts.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)} ${y.toFixed(1)}`).join(" ");
  const last = pts[pts.length - 1];
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={`inline-block overflow-visible ${className}`} aria-hidden="true">
      <path d={d} fill="none" stroke={color} strokeWidth={1.8} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={last[0]} cy={last[1]} r={2.4} fill={color} />
    </svg>
  );
}
